import { BaseModel } from "../base.model";

export class FileBaseModel extends BaseModel {
    fileName?: string;
    fileExt?: string;
    fileSize?: number;
    fileType?: string;
}
